import { apiClient } from '@/core/api/client';
import type { PartnerCompanyLoginInfo } from '../types/partnerCompanyLogin';

export const getPartnerCompanyLoginInfo = async (
  companySlug: string,
): Promise<PartnerCompanyLoginInfo> => {
  const response = await apiClient.get<PartnerCompanyLoginInfo>(
    `/partner-companies/slug/${companySlug}`,
  );
  return response.data;
};
